/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_YearInputs */

const en_reference_field_year = /** @type {(inputs: Reference_Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year`)
};

/**
* | output |
* | --- |
* | "Year" |
*
* @param {Reference_Field_YearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_year = /** @type {((inputs?: Reference_Field_YearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_YearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_year(inputs)
});